import React from 'react';
import styles from './Main.module.sass';
import ShapeA from '../../assets/notebook_and_pencils.svg';
import Section, { SectionBackgroundStyle } from '../../reusable/section/Section';
import TallCurvyUnderline from '../../assets/tall_curvy_underline.svg';
import RevealImage from '../../reusable/reveal/RevealImage';

export default class Main extends React.Component {

  render() {
    return (
      <Section style={SectionBackgroundStyle.dark}>
        <RevealImage className={styles.ShapeA} src={ShapeA} />
        <h1 className={styles.Title}>
          <div className={styles.Item}>Our</div>
          <div className={styles.Item}>mission.</div>
        </h1>
        <RevealImage className={styles.TallCurvyUnderline} src={TallCurvyUnderline} />
      </Section>
    )
  }

}
